import { useState, useEffect } from "react";
import { toast } from "sonner";
import { ArrowDownToLine, Check, X } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { money, dateFmt, shortAddr } from "@/lib/format";

export default function AdminDeposits() {
  const [rows, setRows] = useState([]);

  const load = () => api.get("/admin/deposits").then(({ data }) => setRows(data)).catch(() => toast.error("Load failed"));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try {
      await api.post(`/admin/deposits/${id}/${action}`);
      toast.success(`Deposit ${action}d`);
      load();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-deposits-page">
      <h1 className="font-display text-2xl font-bold flex items-center gap-2"><ArrowDownToLine className="w-6 h-6 text-amber-400" /> Deposits</h1>
      <div className="glass rounded-2xl p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-amber-400 uppercase text-xs tracking-wider border-b border-amber-500/20">
            <th className="text-left py-3">User</th><th className="text-left py-3">Amount</th><th className="text-left py-3">TXID</th><th className="text-left py-3">Status</th><th className="text-left py-3">Date</th><th className="text-right py-3">Action</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-800/60" data-testid={`admin-deposit-${r.id}`}>
                <td className="py-3 text-slate-300">{r.user_email}</td>
                <td className="py-3 font-mono-fin gold-text font-bold">{money(r.amount)}</td>
                <td className="py-3 font-mono-fin text-xs text-sky-400">{shortAddr(r.txid)}</td>
                <td className="py-3"><span className={`text-xs px-2 py-1 rounded ${r.status === "verified" ? "bg-emerald-500/15 text-emerald-400" : r.status === "rejected" ? "bg-red-500/15 text-red-400" : "bg-amber-500/15 text-amber-400"}`}>{r.status}</span></td>
                <td className="py-3 text-slate-500 text-xs">{dateFmt(r.created_at)}</td>
                <td className="py-3 text-right">
                  {r.status === "pending" && (
                    <div className="flex gap-2 justify-end">
                      <button data-testid={`approve-deposit-${r.id}`} onClick={() => act(r.id, "approve")} className="p-2 rounded-lg bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25"><Check className="w-4 h-4" /></button>
                      <button data-testid={`reject-deposit-${r.id}`} onClick={() => act(r.id, "reject")} className="p-2 rounded-lg bg-red-500/15 text-red-400 hover:bg-red-500/25"><X className="w-4 h-4" /></button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="py-6 text-center text-slate-500">No deposits yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
